import styled from "styled-components";

const Container = styled.div`
  background-color: #ffffff;
  display: flex;
  flex-direction: row;
  align-items: center;
  height: 100%;
  box-sizing: border-box;
  &:hover {
    cursor: pointer;
  }
  gap: var(--Spacing-075, 12px);
`;

const LogoImg = styled.img`
  margin: 0px 0px 0px 16px;
  display: block;
`;

const AppTitle = styled.div`
  color: var(--Text-Base-Default, #01151d);
  font-family: "Source Sans Pro";
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: -0.04px;
`;

export { Container, LogoImg, AppTitle };
